import { render } from "./ProgramsDetails.vue?vue&type=template&id=73414c4c&scoped=true"
import script from "./ProgramsDetails.vue?vue&type=script&lang=js"
export * from "./ProgramsDetails.vue?vue&type=script&lang=js"

import "./ProgramsDetails.vue?vue&type=style&index=0&id=73414c4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73414c4c"]])

export default __exports__